import { registerBlockType } from '@wordpress/blocks';
import metaData from '../block.json';
import Edit from './edit';
import save from './save';
import './style.scss';

registerBlockType( metaData.name, {
	edit: Edit,
	save,
} );
